module.exports = __webpack_public_path__ + "img/logo.1abb2ed8.svg";